export function getFontStyle(transformer) {
    return Object.freeze({
        italic: transformer.fontStyle('italic'),
    });
}
